import { render, staticRenderFns } from "./withdrawalRecord.vue?vue&type=template&id=6c7f4a68&scoped=true&"
import script from "./withdrawalRecord.vue?vue&type=script&lang=js&"
export * from "./withdrawalRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7f4a68",
  null
  
)

export default component.exports